import { useRouter } from 'next/router';
import { useState } from 'react';
import { useConditionalEffect, useIsMounted } from '@react-hookz/web';
import useNotificationPreferences from './useNotificationPreferences';
import { useAuth0User } from '@hooks/useAuth0User';

const useNotificationPreferencesGuard = () => {
  const isMounted = useIsMounted();
  const router = useRouter();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { user } = useAuth0User();
  const { hasPreferences, isLoading, isFeatureEnabled, isNewUser } =
    useNotificationPreferences();

  const exemptPaths = [
    '/login',
    '/welcome',
    '/ai-team-rating',
    '/forgot-password',
    '/privacy-policy',
    '/notifications'
  ];

  const isExemptPath = exemptPaths.some((path) =>
    router.pathname.startsWith(path)
  );

  useConditionalEffect(
    () => {
      if (isMounted()) {
        setIsRedirecting(true);
        router.replace('/notifications');
      }
    },
    [
      isFeatureEnabled,
      user,
      router,
      router.pathname,
      hasPreferences,
      isLoading,
      isRedirecting,
      isMounted
    ],
    [
      isFeatureEnabled,
      !isRedirecting,
      user,
      !isExemptPath,
      !isLoading,
      !hasPreferences,
      isNewUser
    ]
  );
};

export default useNotificationPreferencesGuard;
